import merge from 'lodash/merge';
import { Dimensions, StatusBar, StyleSheet } from 'react-native';
import { modalConfig, tokens } from '../../constants';
import { TRANSPARENT } from '../../constants/colors';
import { checkIsPlatform } from '../../utils';
export var getModalWidth = size => {
  var modalTypes = {
    xs: 391,
    sm: 599,
    md: 805,
    lg: 1222
  };
  return modalTypes === null || modalTypes === void 0 ? void 0 : modalTypes[size];
};
export var getModalStyles = function getModalStyles(props, keyboardVisible, keyboardHeight, top, bottom) {
  if (top === void 0) {
    top = 0;
  }
  if (bottom === void 0) {
    bottom = 0;
  }
  var config = props.config,
    width = props.width,
    maxHeight = props.maxHeight,
    maxWidth = props.maxWidth,
    height = props.height,
    _props$enableFullView = props.enableFullView,
    enableFullView = _props$enableFullView === void 0 ? false : _props$enableFullView,
    _props$enableCrossSta = props.enableCrossStartPadding,
    enableCrossStartPadding = _props$enableCrossSta === void 0 ? true : _props$enableCrossSta,
    heightPercentage = props.heightPercentage,
    _props$headerTitle = props.headerTitle,
    headerTitle = _props$headerTitle === void 0 ? '' : _props$headerTitle,
    showHeaderTitle = props.showHeaderTitle,
    showSubTitle = props.showSubTitle,
    showCross = props.showCross,
    maxHeightPercentage = props.maxHeightPercentage,
    _props$modalSize = props.modalSize,
    modalSize = _props$modalSize === void 0 ? 'md' : _props$modalSize,
    swipeEnabled = props.swipeEnabled,
    disableContentPadding = props.disableContentPadding,
    _props$enableSafeArea = props.enableSafeAreaView,
    enableSafeAreaView = _props$enableSafeArea === void 0 ? false : _props$enableSafeArea,
    _props$subTitle = props.subTitle,
    subTitle = _props$subTitle === void 0 ? '' : _props$subTitle;
  var spacing = tokens.spacing;
  var borderRadius = tokens.borderRadius;
  var windowHeight = Dimensions.get('window').height;
  var _height = heightPercentage ? windowHeight * heightPercentage / 100 : height;
  var _maxHeight = maxHeightPercentage ? windowHeight * maxHeightPercentage / 100 : maxHeight;
  if (keyboardVisible) {
    _maxHeight = windowHeight - keyboardHeight - StatusBar.currentHeight - top;
  }
  var headerContentLeftMarginRight = 0;
  if (showCross && enableCrossStartPadding) {
    headerContentLeftMarginRight = enableFullView ? spacing.SPACING_52 : spacing.SPACING_32;
  }
  var crossContainerMarginTop = 0;
  if (enableFullView && !swipeEnabled) {
    crossContainerMarginTop = spacing.SPACING_20;
  }
  var headerIconStyles = {
    position: 'absolute',
    top: 0,
    marginTop: crossContainerMarginTop,
    width: 24,
    height: 24,
    borderRadius: borderRadius.BORDER_RADIUS_24,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    zIndex: 1
  };
  return StyleSheet.create({
    wrapper: {
      flex: 1,
      backgroundColor: config.backgroundColor
    },
    mask: {
      flex: 1,
      backgroundColor: TRANSPARENT
    },
    maskLargeScreen: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center'
    },
    container: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      position: 'relative',
      width: '100%',
      maxWidth: '100%',
      backgroundColor: config.containerBackgroundColor,
      overflow: 'hidden',
      borderTopLeftRadius: borderRadius.BORDER_RADIUS_24,
      borderTopRightRadius: borderRadius.BORDER_RADIUS_24,
      padding: enableFullView ? spacing.SPACING_0 : spacing.SPACING_20
    }, disableContentPadding && {
      padding: spacing.SPACING_0
    }), _height && {
      height: _height
    }), {
      maxHeight: _maxHeight
    }), checkIsPlatform('web') && {
      cursor: 'default'
    }), enableSafeAreaView && !checkIsPlatform('web') && {
      paddingBottom: bottom
    }),
    containerLargeScreen: {
      alignSelf: 'center',
      width: width || getModalWidth(modalSize),
      maxWidth: maxWidth || getModalWidth(modalSize),
      borderRadius: borderRadius.BORDER_RADIUS_16
    },
    draggableContainer: Object.assign({
      width: '100%',
      alignItems: 'center',
      backgroundColor: TRANSPARENT,
      marginTop: enableFullView ? spacing.SPACING_20 : 0
    }, disableContentPadding && {
      paddingTop: spacing.SPACING_20,
      paddingHorizontal: spacing.SPACING_20
    }),
    notch: {
      width: 45,
      height: 6,
      alignSelf: 'center',
      backgroundColor: config.notchBackgroundColor,
      borderRadius: borderRadius.BORDER_RADIUS_10,
      marginBottom: spacing.SPACING_20
    },
    headerContainer: Object.assign(Object.assign(Object.assign({
      flexDirection: 'row'
    }, showHeaderTitle && !!headerTitle || showSubTitle && !!subTitle ? {
      paddingBottom: enableFullView ? spacing.SPACING_0 : spacing.SPACING_16
    } : Object.assign({}, showCross && {
      paddingBottom: spacing.SPACING_30
    })), {
      width: '100%',
      zIndex: 1
    }), disableContentPadding && {
      paddingHorizontal: spacing.SPACING_20,
      paddingBottom: spacing.SPACING_16
    }),
    headerContentLeft: {
      flex: 1,
      marginRight: headerContentLeftMarginRight
    },
    backContainerStyles: Object.assign(Object.assign({}, headerIconStyles), {
      left: enableFullView ? spacing.SPACING_20 : spacing.SPACING_0,
      backgroundColor: config.backBtnBackgroundColor
    }),
    crossContainerStyle: Object.assign(Object.assign({}, headerIconStyles), {
      right: enableFullView ? spacing.SPACING_20 : spacing.SPACING_0,
      backgroundColor: config.crossBackgroundColor
    }),
    subTitle: Object.assign({}, !!headerTitle && {
      marginTop: spacing.SPACING_4
    }),
    lottie: {
      position: 'absolute',
      height: '100%',
      width: '100%',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 99
    }
  });
};
export var getModalProps = (props, context) => {
  var _a;
  var theme = props.theme || context.theme;
  var configProps = merge(modalConfig === null || modalConfig === void 0 ? void 0 : modalConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.modal) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};